<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      @for (owner of owners.controls; track owner; let index = $index) {
        <ng-container [formGroup]="owner">
          <div class="formControl mt">
            <div class="row">
              <div class="col-md-6">
                <pr-input-column
                  label="Prénom du conjoint(e)"
                  [derrors]="derrors"
                >
                  <input formControlName="userSpouseFirstName" type="text" />
                </pr-input-column>
              </div>
              <div class="col-md-6">
                <pr-input-column
                  label="Nom du conjoint(e)"
                  [derrors]="derrors"
                >
                  <input formControlName="userSpouseLastName" type="text" />
                </pr-input-column>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <pr-input-column
                  label="Nom de naissance du conjoint(e)"
                  [derrors]="derrors"
                >
                  <input formControlName="userSpouseBirthName" type="text" />
                </pr-input-column>
              </div>
              <div class="col-md-6">
                <pr-input-date
                  label="Date de naissance du conjoint(e)"
                  formControlName="userSpouseBirthDate"
                  [derrors]="derrors"
                  [isDefault]="false"
                ></pr-input-date>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <pr-input-column
                  label="Ville de naissance du conjoint(e)"
                  [derrors]="derrors"
                >
                  <input formControlName="userSpouseBirthCity" type="text" />
                </pr-input-column>
              </div>
              <div class="col-md-6">
                <pr-input-column
                  label="Email du conjoint(e)"
                  [derrors]="derrors"
                >
                  <input formControlName="userSpouseEmail" type="text" />
                </pr-input-column>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <pr-input-map
                  label="Saisissez l'adresse de la résidence principale du conjoint(e)"
                  formGroupName="spouseAddress"
                  documentMapId="spouseAddressMap"
                  [isGMaps]="!isSwisslifeProduct"
                  [isSwisslifeProduct]="isSwisslifeProduct"
                  [countries]="countries"
                  [derrors]="derrors"
                  [isDefault]="false"
                >
                </pr-input-map>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ng-container formArrayName="userSpouseContactPhones">
                  @for (
                    item of owner.get('userSpouseContactPhones')['controls'];
                    track item
                  ) {
                    <div [formGroup]="item">
                      <pr-input-tel
                        label="Numéro de téléphone mobile du conjoint(e)"
                        [derrors]="derrors"
                        formControlName="phone"
                        [isDefault]="false"
                        type="text"
                      >
                      </pr-input-tel>
                    </div>
                  }
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
